import { useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getVisitorId = () => {
  let id = localStorage.getItem("tbs_vid");
  if (!id) {
    id = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("tbs_vid", id);
  }
  return id;
};

// Mounts inside the Router and records a pageview on every route change.
export const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    axios
      .post(`${API}/track`, {
        path: location.pathname,
        referrer: document.referrer || "",
        visitorId: getVisitorId(),
      })
      .catch(() => {});
  }, [location.pathname]);
  return null;
};
